/* eslint-disable react-hooks/exhaustive-deps */
import { useStore } from '@store'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  Text,
  Button,
  chakra,
  Input,
  IconButton,
} from '@chakra-ui/react'
import { observer } from 'mobx-react-lite'
import useTranslation from 'next-translate/useTranslation'
import { useRef, useEffect } from 'react'
import { useRouter } from 'next/router'
import { Cross } from '@icon'
import { createNavLink } from '@utils'
import { IFonts } from '@interfaces'

interface ISearchModal {
  activeFontFamily?: IFonts
}

const SearchModal = observer(({ activeFontFamily = 'body' }: ISearchModal) => {
  const inputEl = useRef<HTMLInputElement>(null)
  const {
    search: { displaySearchModal, closeSideMenu, searchTerm, setSearchTerm },
  } = useStore()
  const { t } = useTranslation()
  const router = useRouter()

  useEffect(() => {
    return () => {
      handleCloseSearchAction()
    }
  }, [])

  const handleSearchAction = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (searchTerm === '') {
      inputEl.current && inputEl.current.focus()
      return
    }
    closeSideMenu()

    const routerQuery = {
      searchTerm: '',
    }

    routerQuery.searchTerm = searchTerm
    router.push({
      pathname: createNavLink('search', router.locale),
      query: routerQuery,
    })
  }

  const handleCloseSearchAction = () => {
    setSearchTerm('')
    closeSideMenu()
  }

  return (
    <Modal isOpen={displaySearchModal} onClose={closeSideMenu}>
      <ModalOverlay background="transparent" />
      <ModalContent
        mt="48px"
        mb="0"
        maxW="100%"
        minH={{ base: '290px', lg: '154px' }}
        height={{ base: '290px', lg: '154px' }}
        borderRadius="none"
        background="red.primary"
        boxShadow="0px 16px 16px 16px rgba(0, 0, 0, 20%)"
      >
        <ModalBody p="padding.primary">
          <Flex justify="space-between" align="flex-start" gap={4} mb="5">
            <Text
              fontWeight="light"
              fontFamily={activeFontFamily}
              color="white.primary"
            >
              {t('common:searchModal.description')}
            </Text>
            <IconButton
              onClick={handleCloseSearchAction}
              variant="unstyled"
              aria-label={t('common:closeLabel')}
              minW="auto"
              height="auto"
              icon={<Cross width="14px" height="14px" color="white.primary" />}
            />
          </Flex>
          <chakra.form
            display="flex"
            flexDirection={{ base: 'column', lg: 'row' }}
            alignItems={{ base: 'stretch', lg: 'center' }}
            gap={{ base: 4, lg: 0 }}
            mt={{ base: 'padding.primary', lg: '5' }}
            onSubmit={handleSearchAction}
          >
            <Input
              ref={inputEl}
              onChange={(e) => setSearchTerm(e.target.value)}
              px="5"
              type="text"
              fontFamily={activeFontFamily}
              placeholder={t('common:searchModal.searchPlaceholder')}
              variant="secondary"
              size="secondary"
              value={searchTerm}
            />
            <Button
              type="submit"
              fontSize="sm"
              fontWeight="medium"
              fontFamily={activeFontFamily}
              minW={{ base: '10', lg: '110px' }}
              height="50px"
              _hover={{
                bgColor: 'red.primary3',
              }}
            >
              {t('common:searchModal.searchLabel')}
            </Button>
          </chakra.form>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
})

export default SearchModal
